const initialState = {

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TEMPORAL_STATE':
      return {
        ...state,
        [action.name]: action.value,
      };
    default:
      return state;
  }
};

export default reducer;
